/**
 * Per-size stock status on the product page.
 *
 * The info box shows stock for the size that's currently selected rather than
 * the product's combined inventory. Quantities are published by
 * snippets/product-template.liquid; the theme fires `variant:change` with the
 * chosen variant whenever a size is tapped.
 *
 * Sizes with zero stock are also greyed out and struck through. They stay
 * tappable on purpose — tapping one shows SOLD OUT for that size, which reads
 * more clearly than a box that does nothing.
 */
(function () {
  'use strict';

  var LOW_THRESHOLD = 10;

  function rows() {
    return document.querySelectorAll('[data-stock-row]');
  }

  function variantsFor(row) {
    try {
      return JSON.parse(row.getAttribute('data-variants')) || [];
    } catch (e) {
      return [];
    }
  }

  function statusFor(qty) {
    if (qty <= 0) return { cls: 'flowar-dot--red', text: 'SOLD OUT' };
    if (qty <= LOW_THRESHOLD) return { cls: 'flowar-dot--orange', text: 'LOW STOCK' };
    return { cls: 'flowar-dot--green', text: 'IN STOCK' };
  }

  function paint(row, variantId) {
    var list = variantsFor(row);
    var match = null;

    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(variantId)) {
        match = list[i];
        break;
      }
    }
    if (!match) return;

    var status = statusFor(Number(match.q));
    var dot = row.querySelector('[data-stock-dot]');
    var text = row.querySelector('[data-stock-text]');

    if (dot) {
      dot.className = 'flowar-dot ' + status.cls;
    }
    if (text) {
      text.textContent = status.text;
    }
    row.setAttribute('data-variant-id', variantId);
  }

  /* Grey out and strike through any size with no stock left. */
  function markSoldOutSizes(row) {
    var list = variantsFor(row);
    if (!list.length) return;

    var byOption = {};
    list.forEach(function (v) {
      if (v.o != null) byOption[String(v.o)] = Number(v.q);
    });

    document.querySelectorAll('.variant-input[data-value]').forEach(function (wrap) {
      var value = wrap.getAttribute('data-value');
      if (!(value in byOption)) return;
      var label = wrap.querySelector('label');
      if (!label) return;
      label.classList.toggle('disabled', byOption[value] <= 0);
    });
  }

  function init() {
    rows().forEach(function (row) {
      paint(row, row.getAttribute('data-variant-id'));
      markSoldOutSizes(row);
    });
  }

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    rows().forEach(function (row) {
      paint(row, variant.id);
      /* The theme rewrites input states on change, so re-apply ours after. */
      markSoldOutSizes(row);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
